import { Injectable, signal } from '@angular/core';

/**
 * Whether the server has confirmed the session in this page load. The app shows its header and sidebar
 * only then: `/error` is the one route without the auth guard (it must render while the API is down),
 * and an anonymous visitor opening it must not get the logged-in layout.
 */
@Injectable({ providedIn: 'root' })
export class AuthStateService {
  private readonly _confirmed = signal(false);

  readonly confirmed = this._confirmed.asReadonly();

  /** Called by the auth guard when the server answered that the user is logged in. */
  confirm(): void {
    this._confirmed.set(true);
  }
}
